import { useRouter, } from 'next/router';

export default function useArticleId() {
  const router = useRouter();

  return router.query.articleId;
}
